<template>
  <b-row v-if="uploadoption == 'imageupload'" class="choose-file file-height">
    <b-col lg="2" md="2" sm="2" cols="2" class="img-list px-0">
      <ul class="img-list-ul" v-for="(item, index) in srcpreview" :key="index">
        <li @click.stop="(imagereview = true), (selectimage = srcpreview[index]['ImageFile'])">
          <i class="deleteicon pi pi-times" @click.stop="DeleteImage(srcpreview[index])"></i>
          <img alt="Vue logo" class="logo img-responsive" :src="srcpreview[index]['ImageFile']" />
        </li>
      </ul>
    </b-col>
    <b-col lg="10" md="10" sm="10" cols="10" class="file-height">
      <div class="img-upload">
        <div v-if="imagereview">
          <div class="drop-zone" @drop.prevent="onDrop" @dragover.prevent>
            <img alt="Vue logo" class="logo1" :src="selectimage" />
          </div>
        </div>
        <div v-else>
          <div class="drop-zone" @drop.prevent="onDrop" @dragover.prevent>
            <img alt="Vue logo" class="choose-file-icon" src="../../../../assets/Img/icons/drag-and-drop.svg" />
            <span>{{ $t("fileUploade.drag and drop the image") }}</span>
            <input type="file" :multiple="true" data-max_length="20" name="filesend" @change="onFileSelected"
              ref="fileInput" style="display: none" accept="image/*" />
          </div>
        </div>
      </div>

      <b-row class="class1">
        <b-col class="add-img-logo">
          <img class="icon1" src="../../../../assets/Img/icons/dummy-image2.svg" />
          <label>
            {{ $t("fileUploade.addimages") }}
            <input type="file" :multiple="true" data-max_length="20" name="filesend" @change="onFileSelected" />
          </label>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script lang="ts">
import { defineComponent, ref, h, watch, onMounted } from "vue";
import CommonService from "../../Service/CommonService";
export default defineComponent({
  props: {
    uploadoption: {
      type: String,
      default: "",
    },
    imageData: {
      type: Object,
    },
    FileNames: {
      type: Array,
      default: [],
    },
    PorpsImageList: {
      type: Object,
    },
  },

  methods: {
    onFileSelected(event: Event) {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];
      alert(target.files?.[0]);
      this.handleFile(file);
    },
    handleFile(file: File | undefined) {
      if (!file) return;
    },
  },

  setup(props, { emit }) {
    const file = ref();
    const myRef = ref<never[]>([]);
    let imagereview = ref(false);
    let selectimage = ref("");
    let src: any = myRef.value;
    let srcpreview: any = ref([]);
    const imageModel = ref();
    const message = ref("");
    const isLoading = ref(false);
    let deletedImageId: any = ref([])
    function isFileImage(file) {
      return file && file["type"].split("/")[0] === "image";
    }
    function onDrop(event: DragEvent) {
      debugger;
      event.preventDefault();
      const items = event.dataTransfer?.files ?? [];
      if (items!.length <= 5) {
        for (let i = 0; i < items!.length; i++) {
          src.push(items[i]);
          console.log(srcpreview.value);
          uploadFile();
        }
      } else {
        alert("select only 5 images");
      }
      console.log(src);
      imageModel.value = true;
    }

    watch(
      () => props.PorpsImageList,
      (newVal) => {
        debugger;
        if (props.PorpsImageList) {
          // Object.values(props.PorpsImageList).forEach((value) => {
          //   srcpreview.value.push(value);
          // });
          srcpreview.value = props.PorpsImageList
          imagereview.value = true;
          selectimage.value = srcpreview.value[0]["ImageFile"];
        }


      },
      { deep: true }
    );


    function onFileSelected(e) {
      debugger;
      if (src.length < 5) {
        for (let i = 0; i < e.target.files.length; i++) {
          const file = e.target.files[i];
          src.push(file);
          uploadFile();
        }
      } else {
        alert("select only 5 images");
      }
      debugger;
      console.log(src);
      imageModel.value = true;
    }


    async function uploadFile() {
      debugger;
      imageModel.value = false;
      try {
        debugger;
        isLoading.value = true;
        let imgArray: any = ref([]); //
        if (src.length != 0) {
          let i = src.length - 1;
          let form = new FormData();
          let result;
          console.log(src[i]);
          form.append("file", src[i]);
          result = await CommonService.fileupload(form, "ProductImages");
          let ResponseValue = result; //
          imgArray.value.push(ResponseValue["Message"]); //
          console.log(imgArray); //
          srcpreview.value.push({ ImageFile: result.fullPath })
          emit("ImageURL", srcpreview.value);

        }

      } catch (error) {
        // alert(error.message);
      } finally {
        isLoading.value = false;
      }
    }

    function handleFile(file: File | undefined) {
      if (!file) return;
    }
    function DeleteImage(data) {
      debugger
      srcpreview.value = srcpreview.value.filter((item: any) => item.ImageFile !== data['ImageFile']);
      if (data['Id']) {
        deletedImageId.value.push(data['Id'])
      }
      if (selectimage.value == data['ImageFile']) {
        if (srcpreview.value.length > 0) {
          selectimage.value = srcpreview.value[0]['ImageFile']
        }
        else {
          imagereview.value = false
        }
      }
      emit("deletedImageId", deletedImageId.value)
      emit("ImageURL", srcpreview.value);
    }
    return {
      onDrop,
      imagereview,
      srcpreview,
      onFileSelected,
      uploadFile,
      src,
      selectimage,
      DeleteImage
    };
  },
});
</script>

<style lang="scss" scoped>
.drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 200px;
  width: 100%;
  cursor: pointer;
}

label {
  padding: 10px;
  background: transparent;
  display: table;
  color: black;
}

input[type="file"] {
  display: none;
}

.choose-file-icon {
  width: 20%;
  height: 20%;
  align-self: center !important;
}

.choose-img {
  color: #444444;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
}

.choose-file {
  border: 1px solid #e1e1e1;
  border-radius: 5px;
}

.file-height {
  height: 280px;
}

.img-list {
  border-right: 1px solid #e1e1e1;
  // height: 300px;
  height: 100%;
  overflow: auto;
}

.img-list-ul {
  width: 88px;
  height: 88px;
  // margin-bottom: 15px;
}

.img-list-ul li {
  height: 43px;
  border: 1px solid #e1e1e1;
  width: 100%;
}

.img-list-ul li img {
  width: 88%;
}

.img-upload {
  color: #000;
  height: 80%;
  padding: 2%;
}

.icon1 {
  width: 30px;
}

.class1 {
  height: 20%;
}

.add-img-logo {
  width: 50%;
  border-top: 1px solid #e1e1e1;
  border-right: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p-fileupload .p-fileupload-buttonbar {
  background: #ffffff !important;
  padding: 0.25rem !important;
  border: none !important;
}

.p-fileupload .p-fileupload-content {
  padding: 1rem 1rem !important;
  border: none !important;
}

.p-fileupload .p-fileupload-file {
  padding: 0.5rem !important;
}

.p-fileupload .p-fileupload-file-name {
  margin-bottom: 0rem !important;
}

.p-fileupload-file-thumbnail {
  display: none;
}

.p-fileupload-file-size {
  display: none;
}

.p-badge.p-badge-warning {
  display: none;
}

.card {
  padding: 1rem !important;
}

.p-fileupload .p-fileupload-buttonbar {
  justify-content: center;
}

.p-fileupload-buttonbar .p-button {
  color: #3096ff !important;
  background: #ffffff !important;
  border: 1px solid #3096ff !important;
  padding: 0.5rem 0.5rem !important;
}

.p-fileupload-buttonbar .p-button:focus {
  box-shadow: none !important;
}

// .logo {
//   object-fit: cover;
//   object-position: center right;

//   height:70px;
//   margin-top:10px;
//   margin-bottom:10px;
// }

.logo1 {
  height: 200px;
}
</style>
